import Vue from "vue";
import Router from "vue-router";

const SubProduct = () => import("@/pages/CategoryProducts");
const PageProduct = () => import("@/pages/ProductInner");
const NotFound = () => import("@/pages/NotFound");
const Home = () => import("@/pages/Categories");
const Coach = () => import("@/pages/Orders");
const Profile = () => import("@/pages/Profile");
const Store = () => import("@/pages/Home");
const INStore = () => import("@/pages/StoreInner");
const Media = () => import("@/pages/Stores");
const Basket = () => import("@/pages/Basket");
const EditProfile = () => import("@/pages/EditProfile");
const MessageProfile = () => import("@/pages/MessageProfile");
const TransactionProfile = () => import("@/pages/Transactions");
const About = () => import("@/pages/About");
const Address = () => import("@/pages/Address");
const Rep = () => import("@/pages/Representation");
const Splash = () => import("@/pages/Splash");
const Share = () => import("@/pages/Share");
const Tracking = () => import("@/pages/Tracking");
const Cars = () => import("@/pages/Cars");

// const ticket = () => import("@/pages/Tickets");
// const creation = () => import("@/pages/TicketCreate");
// const chatTicket = () => import("@/pages/TicketChats");

Vue.use(Router);

export default new Router({
    mode: "history",
    linkActiveClass: "is-active",
    routes: [
        {
            path: "/about",
            component: About,
            name: "About",
            meta: {
                title: "کلانا | درباره ما",
                header: true,
                footer: false,
            },
        },
        {
            path: "/",
            name: "splash",
            component: Splash,
            meta: {
                title: "کلانا | ورود به کلانا",
                header: false,
                footer: false,
            },
        },
        {
            path: "/address",
            component: Address,
            name: "Address",
            meta: {
                title: "کلانا | آدرس های من",
                header: true,
                footer: false,
            },
        },
        {
            path: "/basket",
            component: Basket,
            name: "Basket",
            meta: {
                title: "کلانا | سبد خرید",
                header: true,
                footer: false,
            },
        },
        {
            path: "/vehicles",
            name: 'Cars',
            component: Cars,
            meta: {
                title: "کلانا | خودرو های من",
                header: true,
                footer: false,
            },
        },
        {
            path: "/categories",
            component: Home,
            name: "Categories",
            meta: {
                title: "کلانا | دسته بندی محصولات",
                header: false,
                footer: true,
            },
        },
        {
            path: "/category-products",
            component: SubProduct,
            name: "CatProducts",
            meta: {
                title: "کلانا | محصولات دسته بندی",
                header: true,
                footer: false,
            },
        },
        {
            path: "/edit-profile",
            component: EditProfile,
            name: "EditProfile",
            meta: {
                title: "کلانا | ویرایش پروفایل",
                header: true,
                footer: false,
            },
        },
        {
            path: "/orders",
            component: Coach,
            name: "Orders",
            meta: {
                title: "کلانا | پیگیری سفارشات",
                header: false,
                footer: true,
            },
        },
        // {
        //     path: "/representation",
        //     component: Rep,
        //     name: "Representation",
        //     meta: {
        //         title: "کلانا | اخذ نمایندگی",
        //         header: true,
        //         footer: false,
        //     },
        // },
        {
            path: "/product-info",
            component: PageProduct,
            name: "ProductInfo",
            meta: {
                title: "کلانا | اطلاعات محصول",
                header: true,
                footer: false,
            },
        },
        {
            path: "/profile",
            component: Profile,
            name: "Profile",
            meta: {
                title: "کلانا | پروفایل کاربری",
                header: false,
                footer: true,
            },
        },
        {
            path: "/main",
            component: Store,
            name: "Home",
            meta: {
                title: "کلانا | خانه",
                header: false,
                footer: true,
            },
        },
        {
            path: "/inbox",
            component: MessageProfile,
            name: "MessageProfile",
            meta: {
                title: "کلانا | صندوق پیام",
                header: true,
                footer: false,
            },
        },
        {
            path: "/store-info",
            component: INStore,
            name: "StoreInfo",
            meta: {
                title: "کلانا | اطلاعات فروشگاه",
                header: true,
                footer: false,
            },
        },
        {
            path: "/stores",
            component: Media,
            name: "Stores",
            meta: {
                title: "کلانا | فروشگاه ها",
                header: false,
                footer: true,
            },
        },
        {
            path: "/transactions",
            component: TransactionProfile,
            name: "Transactions",
            meta: {
                title: "کلانا | تراکنش های مالی",
                header: true,
                footer: false,
            },
        },
        {
            path: "/share",
            component: Share,
            name: "Share",
            meta: {
                title: "کلانا | اشتراک گذاری",
                header: true,
                footer: false,
            },
        },
        {
            path: "/tracking",
            name: 'Tracking',
            component: Tracking,
            meta: {
                title: "کلانا | پیگیری سفارش",
                header: true,
                footer: false,
            },
        },
        // {
        //     path: "/ticket-create",
        //     component: creation,
        //     meta: {
        //         title: "کلانا | ایجاد تیکت پشتیبانی",
        //         header: true,
        //         footer: false,
        //     }
        // },
        // {
        //     path: "/ticket-messages",
        //     component: chatTicket,
        //     meta: {
        //         title: "کلانا | مشاوره با پشتیبانی",
        //         header: true,
        //         footer: false,
        //     }
        // },
        // {
        //     path: "/ticket",
        //     component: ticket,
        //     meta: {
        //         title: "کلانا | تیکت های پشتیبانی",
        //         header: true,
        //         footer: false,
        //     }
        // },
        {
            path: "*",
            name: "NotFound",
            component: NotFound,
            meta: {
                title: "کلانا | صفحه مورد نظر یافت نشد",
                header: false,
                footer: false,
            },
        }
    ],
});
